module.exports = __webpack_public_path__ + "img/hr-tree-08-e-leaves.50798495.png";